import { createSelector } from 'reselect'
import { pick } from 'util/objects'
import { selectOnboarding } from '../../selectors'

const DEFAULT_FORM_FIELDS = {
  numberOfEmployeesInput: '',
  customHelpInput: '',
}

const selectBase = createSelector(
  selectOnboarding,
  onboarding => onboarding.customerInformation || {}
)

export function selectFormFields(state) {
  return pick(
    ['numberOfEmployeesInput', 'customHelpInput', 'industryInput'],
    { ...DEFAULT_FORM_FIELDS, ...selectBase(state) },
    true
  )
}

export const selectNextPage = createSelector(selectBase, base => base.nextPage)
